<template>
  <div class="map">
    <GmapMap :zoom="zoom" :center="center" class="map" :options="options" ref="googleMap"></GmapMap>
  </div>
</template>

<script>
import { gmapApi } from "vue2-google-maps";

export default {
  name: "GoogleMap",
  props: {
    center: {
      type: Object,
      default: function () {
        return {
          lat: 0.0,
          lng: 0.0,
        };
      },
    },
    options: Object,
    zoom: Number,
    showHeatmap: Boolean,
    heatmapPoints: Array,
  },
  data: function () {
    return {
      locationMarkers: [],
      locPlaces: [],
      existingPlace: null,
    };
  },
  computed: {
    google: gmapApi,
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.googleMap.$mapPromise.then(() => {
        let latLon = new this.google.maps.MVCArray();
        this.heatmapPoints.forEach((coord) => {
          latLon.push(new this.google.maps.LatLng(coord.lat, coord.long));
        });
        let x = new this.google.maps.visualization.HeatmapLayer({
          data: latLon,
          map: this.$refs.googleMap.$mapObject,
          dissipating: true,
          radius: 10,
          maxIntensity: 10,
          opacity: 1,
        });
      });
    });
  },
  methods: {
    initMarker() {},
  },
};
</script>

<style scoped>
.map {
  width: inherit;
  height: inherit;
}
</style>
